/* eslint-disable line-comment-position */
import React from 'react'
import {
	Upload
}from "antd"
import Notifications from './Notifications'

const validFormats = [
	'image/jpeg',
	'image/png',
	'application/pdf',
	'image/tiff',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
	'application/msword', //doc
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' //xlsx
]

const validFormatExcel = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

function validateFile(file, isExcel){
	const isValidFormat = isExcel ? (validFormatExcel.indexOf(file.type) != -1) : (validFormats.indexOf(file.type) != -1) || (file.type === 'application/vnd.ms-excel'&&(file.name.endsWith(".xls"))) //здесь дополнительно проверяю потому что такой тип имеет csv и xls файлы
	const isLess15MB = file.size / 1024 / 1024 < 15
	const errorMessage = `${ !isValidFormat ? 'Недоступный формат файла.' : `` }\n${ !isLess15MB ? 'Размер файла больше 15МБ.' : `` }`.trim()
	if (errorMessage){
		const description =(
			<span style={ { whiteSpace: "pre-wrap" } }>
				{ errorMessage }
			</span>
		)
		Notifications.errorNotice('Ошибка загрузки файла', description, 20)
	}
	return isLess15MB && isValidFormat? false : Upload.LIST_IGNORE
}

export default validateFile